import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";
import { StudentAction, MeetingAction } from "../../store/actions";
import {
  meeting,
  boxContainer,
  Spacer,
  inputFields,
  Loader,
  datepicker,
  upload,
  Buttons,
} from "../../components";
import { Images, Utils } from "../../config";
import TimeSlots from "../../config/utility-arrays/timeslots";
const AddMeeting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const profileData = useSelector((state) => state.profile?.user);
  const schoolId =
    profileData?.role === "school"
      ? profileData?.schoolId
      : profileData?.staff?.schoolId;
  const { activeStudents, isLoading } = useSelector((state) => state.students);
  const meetingLoading = useSelector((state) => state.meeting?.isLoading);
  const timeslots = useSelector((state) => state.meeting?.timeslots);
  const timeslotLoading = useSelector(
    (state) => state.meeting?.isTimeslotLoading
  );

  const [buttonText, setButtonText] = useState("Schedule");
  const [studentList, setStudentList] = useState([]);
  const [timeSlot, setTimeSlot] = useState([]);
  const [state, setState] = useState({
    subject: "",
    meetingDate: "",
    timeSlot: null,
    message: "",
    meetingType: "",
    organizer: "school",
    studentUserId: null,
    meetingLink: "",
    meetingFile: "",
  });
  useEffect(() => {
    if (location?.state?.studentUserId) {
      setState({ ...state, studentUserId: location?.state?.studentUserId });
    }
  }, [location?.state]);

  useEffect(() => {
    if (activeStudents.length === 0) {
      const payload = { schoolId };
      dispatch(StudentAction.getActiveStudents(payload));
    }
  }, [profileData]);

  useEffect(() => {
    setState({ ...state, timeSlot: null });
    if (profileData?.id && state?.meetingDate) {
      const payload = {
        userId: profileData?.id,
        date: state?.meetingDate,
      };
      dispatch(MeetingAction.getTimeslots(payload));
    }
  }, [state?.meetingDate, profileData]);

  useEffect(() => {
    const filteredTimeslots = timeslots.map((timeslot) => ({
      label: timeslot?.timeSlot,
      value: timeslot?.id,
    }));
    setTimeSlot(filteredTimeslots);
  }, [timeslots]);

  useEffect(() => {
    const filteredStudents = activeStudents.map((student) => ({
      label: `${student?.firstName} ${student?.lastName}`,
      value: student?.id,
    }));
    setStudentList(filteredStudents);
  }, [activeStudents]);

  const handleSubmit = () => {
    if (
      !state.studentUserId ||
      !state?.subject ||
      !state?.meetingDate ||
      !state?.timeSlot ||
      !state?.meetingType ||
      !state?.meetingLink
    ) {
      message.error("Please fill all the required fields.");
    } else if (
      state?.meetingType === "online" &&
      state?.meetingLink &&
      !Utils?.isValidURL(state.meetingLink)
    ) {
      message.error("Please enter a valid meeting link.");
    } else {
      setButtonText("Scheduling");
      const payload = {
        ...state,
        counselorUserId: profileData?.id,
        schoolId: profileData?.schoolId ?? profileData?.staff?.schoolId,
      };
      console.log(payload);
      dispatch(
        MeetingAction.addMeeting(payload, (res) => {
          if (res.status === 200) {
            navigate("/meetings/sent");
          }
          setButtonText("Schedule");
        })
      );
    }
  };
  const radioItems = [
    { label: "In Person", value: "offline" },
    { label: "Online", value: "online" },
  ];
  return (
    <div className="text-black">
      <div className="header-md pl-3">Schedule New Meeting</div>
      <Spacer height={20} />
      <boxContainer.LiteBoxContainer>
        <div className="text-[1.25em] font-semibold">
          Fill in your details and schedule a meeting.
        </div>
        <Spacer height={25} />
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-2">
            <meeting.AddMeetingBoxLabel
              title="Select Student"
              required={true}
            />
            {isLoading ? (
              <Loader.Circular />
            ) : (
              <inputFields.SelectDropdown
                items={studentList}
                onChange={(e) => setState({ ...state, studentUserId: e })}
                value={state?.studentUserId}
                placeholder="Select student"
              />
            )}
          </div>
          <div className="flex flex-col gap-2">
            <meeting.AddMeetingBoxLabel title="Subject" required={true} />
            <inputFields.DefaultInput
              onChange={(e) => setState({ ...state, subject: e.target.value })}
              value={state.subject}
              placeholder="Enter subject"
            />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="flex flex-col gap-2">
              <meeting.AddMeetingBoxLabel title="Select date" required={true} />
              <datepicker.DefaultDatepicker
                datevalue={state?.meetingDate}
                onChange={(date, dateString) =>
                  setState({ ...state, meetingDate: dateString })
                }
                disableprevious={true}
              />
            </div>
            <div className="flex flex-col gap-2">
              <meeting.AddMeetingBoxLabel
                title="Select Timeslot"
                required={true}
              />
              <inputFields.SelectDropdown
                items={timeSlot}
                onChange={(e) => setState({ ...state, timeSlot: e })}
                value={state?.timeSlot}
                placeholder="Select time slot"
              />
            </div>
            <div className="flex flex-col gap-2">
              <meeting.AddMeetingBoxLabel title="Document Attachment" />
              <upload.DefaultFileUpload
                onChange={(file) => setState({ ...state, meetingFile: file })}
                value={state.meetingFile}
                icon={Images.DocumentAttachment}
              />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <meeting.AddMeetingBoxLabel title="Message" />
            <inputFields.DefaultTextbox
              onChange={(e) => setState({ ...state, message: e.target.value })}
              value={state.message}
              placeholder="Enter message"
            />
          </div>
          <div className="flex flex-col gap-2">
            <meeting.AddMeetingBoxLabel
              title="Select mode of meeting"
              required={true}
            />
            <div className="flex gap-[100px] items-center">
              <div className="pl-2">
                <inputFields.VerticalRadio
                  items={radioItems}
                  onChange={(e) =>
                    setState({ ...state, meetingType: e.target.value })
                  }
                  value={state.meetingType}
                />
              </div>
              {state.meetingType && (
                <div className="flex flex-col gap-2 w-[500px]">
                  <meeting.AddMeetingBoxLabel
                    title={
                      state.meetingType === "offline"
                        ? "Add Location"
                        : "Attach Link"
                    }
                    required={true}
                  />
                  <inputFields.DefaultInput
                    onChange={(e) =>
                      setState({ ...state, meetingLink: e.target.value })
                    }
                    value={state.meetingLink}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <Spacer height={30} />
        <div className="flex w-full justify-end">
          <Buttons.DefaultButton
            disabled={meetingLoading}
            onClick={handleSubmit}
            loading={meetingLoading}
          >
            {buttonText}
          </Buttons.DefaultButton>
        </div>
      </boxContainer.LiteBoxContainer>
    </div>
  );
};
export default AddMeeting;
